module.exports = __webpack_public_path__ + "static/media/pattern-2.700f0a41.png";